import { RequestItem } from './OfferItem';

export const RequestsOffer = () => <RequestItem />;
